"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgComments(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M21.63 8.286C23.06 9.283 24 11.211 24 13c0 2.408-1.347 4.56-3.595 6.061.095.709.318 1.302.629 1.795.214.34.42.562.551.672l.052.04c.566.406.342 1.294-.348 1.383l-.172.016a6.609 6.609 0 01-3.42-.681 5.76 5.76 0 01-1.77-1.37l-1.377-.001-.41-.007c-1.51-.05-2.95-.368-4.194-.936l-.335-.161a.766.766 0 11.693-1.367c1.105.56 2.44.882 3.86.932l.39.007H16.318a.77.77 0 01.039.003l-.07-.003a.77.77 0 01.54.22l.016.019c.019.019.037.04.054.062.412.54.912.945 1.486 1.233.358.18.726.308 1.087.394l.066.012-.082-.154a6.238 6.238 0 01-.597-2.109l-.029-.345V18.66v.034-.053a.763.763 0 01.019-.146l.009-.032a.559.559 0 01.02-.066l.011-.025a.562.562 0 01.027-.058l.013-.022.039-.062a1.095 1.095 0 01.062-.077l.03-.03a.641.641 0 01.044-.042l.032-.024a.609.609 0 01.054-.038c.003 0 .006-.003.01-.005 2.068-1.25 3.27-3.046 3.27-5.013 0-1.302-.708-2.756-1.715-3.457a.766.766 0 11.875-1.257zM9.446 1c5.187 0 9.446 3.508 9.446 7.915 0 4.327-4.105 7.787-9.164 7.911l-.282.004-1.374.001a5.766 5.766 0 01-1.766 1.368 6.606 6.606 0 01-3.424.683l-.171-.016c-.652-.084-.888-.881-.436-1.31l.087-.073c.125-.09.358-.323.602-.71a4.459 4.459 0 00.632-1.796C1.346 13.475 0 11.324 0 8.915 0 4.508 4.26 1 9.447 1zm0 1.532c-4.4 0-7.915 2.895-7.915 6.383 0 1.968 1.2 3.764 3.269 5.013l.011.007c.016.01.032.02.047.032l-.058-.039a.771.771 0 01.232.217l.02.031a.667.667 0 01.082.178.757.757 0 01.035.269l-.001.007c-.056.934-.278 1.752-.625 2.455l-.083.154.07-.014c.27-.064.545-.152.817-.269l.27-.125a4.247 4.247 0 001.485-1.232.768.768 0 01.13-.135l.015-.01a.596.596 0 01.053-.037l.038-.022a.53.53 0 01.1-.047.6.6 0 01.14-.039l.029-.004.035-.004a.77.77 0 01.039-.003H9.447c4.4 0 7.915-2.895 7.915-6.383s-3.515-6.383-7.915-6.383z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgComments;
exports.default = _default;